const onCustomerLogin = (user) => {
    try {
      const {country, lang} = getCountryAndLanguage();
      const host = window.location.host;
      const userData = {
        emailId: user?.emailId,
        password : user?.password,
        rememberMeChecked: user?.rememberMeChecked
      }

      let triggerAPI = CookieService.getCookie('rodeoR4Experience' || false);
      if (triggerAPI) {
        getCustomerSignOnR4API(country, lang, userData);
      } else {
        getCustomerSignOnR3API(country, lang, userData, host);
      }
    } catch (e) {
      console.error("Catch: ", e);
    }
  };

  function setR3DataInStorage(sessionId, encryptedSessionId, userData, country, customerProfile) {
    try {
      const accountNbr = customerProfile?.data?.customerProfile?.customer?.accountNumber
      const registrationDate = customerProfile?.data?.customerProfile?.customer?.registrationDate
      let sender = {};
      const countryIsoCode = country.toUpperCase();
      if (accountNbr) {
        sender = {
          "email": userData.emailId,
          "verificationStatus": "N",
          "termsConditionFlag": "1",
          "myWuNumber": accountNbr,
          "isLoggedIn": true,
          "address": {
            "countryIsoCode": countryIsoCode
          },
          "additionalPreferedAccountNumber": accountNbr,
          "issueDate": registrationDate?.split(' ')[0]?.replace(/-/g, ""),
          "mobileNumber": {},
          "identityVerificationStatus": "N",
          "accountPreferences": {
            "optOutMarketing": "true",
            "directMail": "false",
            "message": "false",
            "email": "true",
            "telephoneCall": "false",
            "optInShare": "true",
            "thirdpartyDatasharingConsent": "true",
            "whatsAppMsg": "false"
          },
          "registrationDetails": {
            "registrationDate": registrationDate,
            "registrationStatus": "P"
          },
          "customerLevelCode": customerProfile?.data?.customerProfile?.customer?.customerLevelCode// profile
        }
      } else {
        sender = {
          email: userData.emailId,
          password: userData.password
        }
      }
      const countryNameEl = document.querySelector("#footer-country-dropdown .b-flag-select__value");
      let receiverCountry = window.receiverCountry;
      const receiverCountryName = countryCurrencyDefaults?.countries?.filter((cdata) => cdata.country.isCode === receiverCountry)[0]?.country?.name;
      const data = {
        sessionId: sessionId,
        encryptedSessionId: encryptedSessionId,
        sender: sender,
        corridor: {
          senderCountry: {
            isoCode: countryIsoCode,
            name: countryNameEl?.innerText
          },
          receiverCountry: {
            isoCode: receiverCountry,
            name: receiverCountryName
          },
          receiverCurrency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry],
          senderCurrency: ISO_CODES_COUNTRIES_CURRENCIES[countryIsoCode],
          senderCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[countryIsoCode] }],
          receiverCurrencyArray: [{ currency: ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry] }],

        }
      };
      const jsonData = JSON.stringify(data);
      sessionStorage.setItem("app", jsonData);
      sessionStorage.setItem("cookiestore", jsonData);
      sessionStorage.setItem('sc_login_success', true);
      CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
      CookieService.setCookie('EncryptedSessionId', encryptedSessionId, 30, `/${country}/${lang}`, true, ".westernunion.com");
    } catch (e) {
      console.log(e)
    }
  }


  const getCustomerSignOnR4API = (country, lang, userData) => {
    triggerRouterCreateSession(country, lang) //add create session api
      .then(({  sessionId, encryptedSessionId, clientIp, dataCenter  }) => {
        if (sessionId) {
          const r4SessionId = sessionId;
          const r4encryptedSessionId = encryptedSessionId;
          const r4ClientIp = clientIp;
          const r4dataCenter = dataCenter;
          getCustomerR4API( r4SessionId, r4encryptedSessionId, r4ClientIp, r4dataCenter, country, lang, userData);
        } else {
        }
      })
      .catch((error) => {
        console.error("error from trigger create Session : ", error);
      });
  };

  const getCreateSessionR3API = (country, lang, host) => {
    const createSessionSingonR3 = triggerCreateSession(country, lang, host);
      return httpRequest.post(createSessionSingonR3.createSessionurl, createSessionSingonR3.reqPayload, { "Content-type": "application/json" })
        .then((response) => {
          const clientIp = response?.security?.client_ip ? response.security.client_ip : '245024209201';
          const sessionId = response?.security?.session.id;
          const encryptedSessionId = response?.security?.session?.encrypted_session_id;
          setCookieOnCreateSessionResponse(response);
          return {
            clientIp,
            sessionId,
            encryptedSessionId
          }
        }).catch ((e) => {
      console.error('error from trigger Session API  : ', e)
    });
  }
  
  const getSignOnR3APIs = (country, lang, userData, host, responses) => {
    if (responses?.clientIp && responses?.sessionId) {
      const {clientIp, sessionId, encryptedSessionId} = responses;
      triggerCustomerSignOn(country, lang, sessionId, clientIp, userData, host)
        .then((singOnResponse) => {
          if (singOnResponse?.error?.code) {
            storeErrorResponseAndSession(singOnResponse, sessionId, clientIp, encryptedSessionId);
            location.href = `/${country}/${lang}/web/user/login`;
          }
          else {
            const accNumber = singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr;
            const successType = 'sc_login_success';
            triggerGetTransactionDetails(sessionId, clientIp, accNumber, host).then((transactionResponse) => {
            setR3SendeGatewayrDetails(sessionId, encryptedSessionId, country, lang, userData, singOnResponse, successType);
            updateUserIdentity(singOnResponse);
            triggerGetCustomerVerificationStatus(sessionId, clientIp, accNumber, host).then((customerVerificationResponse) => {
              setR3CustomerVerificationStatus(customerVerificationResponse);
                triggerGetLoyaltycards(sessionId, clientIp, accNumber, host).then((loyalityResponse) => {
                  setR3LoyalityCard(loyalityResponse);
                  if (userData?.rememberMeChecked) {
                    CookieService.setCookie("User_Email", userData?.emailId, 365,'/', true, ".westernunion.com");
                  }
                  if (transactionResponse?.transactions?.transaction?.length > 0) {
                      location.href = `/${country}/${lang}/web/account/history`;
                  } else {
                      location.href = `/${country}/${lang}/web/send-money/start`;
                  }
                }).catch(error => {
                  console.error(error);
                })
              }).catch(error => {
                console.error(error);
              });
            }).catch(error => {
              console.error(error);
            })
          }
        }).catch(error => {
          console.error(error)
        })
    }
  }
  
  const getCustomerSignOnR3API = (country, lang, userData, host) => {
    let responses = {
      sessionId: CookieService.getCookie('SessionId'),
      clientIp: CookieService.getCookie('ClientIp'),
      encryptedSessionId: CookieService.getCookie('EncryptedSessionId')
    };
    
    // checking if no existing session then trigger session api
    if(!responses?.sessionId) {
      const responseObj = getCreateSessionR3API(country, lang, host);
      responseObj.then((response) => {
        responses['sessionId'] = response?.sessionId;
        responses['clientIp'] = response?.clientIp;
        responses['encryptedSessionId'] = response?.encryptedSessionId;
        getSignOnR3APIs(country, lang, userData, host, responses);
     });
    } else {
      getSignOnR3APIs(country, lang, userData, host, responses);
    }
  }

const getCustomerR4API = (
  r4SessionId,
  r4encryptedSessionId,
  r4ClientIp,
  r4dataCenter,
  country,
  lang,
  userData
) => {
  triggerRouterSignInCustomer(r4SessionId, country, lang, userData) //sign api
    .then((signInData) => {
      if (signInData?.data?.signIn?.errorCode) {
        location.href = `/${country}/${lang}/web/user/login`;
      } else {
        window.queryData.triggerCustomerProfile(
          r4SessionId,
          signInData?.data?.signIn?.token?.accessToken,
          country,
          lang
        )
          .then((customerProfile) => {
            if (customerProfile?.data?.customerProfile?.errorCode) {
              location.href = `/${country}/${lang}/web/user/login`;
            } else {
              setDataInStorageR4(
                customerProfile,
                signInData,
                lang,
                userData,
                country,
                r4SessionId,
                r4encryptedSessionId,
                r4ClientIp,
                r4dataCenter
              );
              setR3DataInStorage(
                r4SessionId,
                r4encryptedSessionId,
                userData,
                country,
                customerProfile
              );
              const accNumber =
                customerProfile?.data?.customerProfile?.customer
                  ?.accountNumber;
              sessionStorage.setItem("AccountNumber", accNumber);
              const prepaidToken =
                signInData?.data?.signIn?.token?.prepaidToken || "";
              sessionStorage.setItem("prepaidToken", prepaidToken);
              location.href = `/${country}/${lang}/web/send-money/start`;
            }
          })
          .catch((e) => {
            console.error("error from trigger customerProfile : ", e);
          });
      }
    })
    .catch((e) => {
      console.error("error from trigger SingIn Session : ", e);
    });
};

